import React, { useCallback } from 'react';
import { Button, Table } from 'react-bootstrap';
import { IGetEmailsResponse } from '../../../interfaces/api/IEmails';
import { usePostMailsResendMutation } from '../../../services/api/repositories/EmailsRepository';
import Moment from 'react-moment';

export default function TableMails({
    data,
    setResendEmailResponseMessage,
    setShowAlert
}: {
    data: IGetEmailsResponse;
    setResendEmailResponseMessage: React.Dispatch<React.SetStateAction<string | null>>;
    setShowAlert: React.Dispatch<React.SetStateAction<boolean>>;
}) {
    return (
        <div className='table-container'>
            <Table className='list mailings-history' responsive>
                <thead>
                    <tr>
                        <th className='timestamp key'>Date/Heure</th>
                        <th className='type'>Type envoi</th>
                        <th className='store'>Magasin</th>
                        <th className='recipient'>Destinataire</th>
                        <th className='mailing'>Envoi</th>
                        <th className='actions'>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.emails.length === 0 && (
                        <tr>
                            <td colSpan={6} className='no-results'>
                                Aucun résultat
                            </td>
                        </tr>
                    )}
                    {data.emails.length > 0 && <TableRow data={data} setResendEmailResponseMessage={setResendEmailResponseMessage} setShowAlert={setShowAlert} />}
                </tbody>
            </Table>
        </div>
    );
}

function TableRow({
    data,
    setResendEmailResponseMessage,
    setShowAlert
}: {
    data: IGetEmailsResponse;
    setResendEmailResponseMessage: React.Dispatch<React.SetStateAction<string | null>>;
    setShowAlert: React.Dispatch<React.SetStateAction<boolean>>;
}) {

    const [postMailsResend] = usePostMailsResendMutation();

    const handleResendEmail = useCallback(async (uuid: string) => {
        try {

            const response = (await postMailsResend({ uuid: uuid }).unwrap()).message;

            setResendEmailResponseMessage(response);
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 5000);

        } catch (error) {
            setResendEmailResponseMessage('Une erreur est survenue lors du renvoi de l\'email');
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 5000);
        }
    }, [postMailsResend, setResendEmailResponseMessage, setShowAlert]);

    const rows = data.emails.map((email, indexEmail) => {
            return (
                <tr key={indexEmail}>
                    <td className='timestamp key'>
                        <Moment format='DD/MM/YYYY HH:mm:ss'>
                            {email.date}
                        </Moment>
                    </td>
                    <td className='type'>{email.type}</td>
                    <td className='store'>{email.store}</td>
                    <td className='recipient'>{email.client}</td>
                    <td className='mailing'>{email.name}</td>
                    <td className='actions'>
                        <div className='btns-wrapper'>
                            <Button
                                onClick={() => handleResendEmail(email.email_uuid)}
                                variant='secondary'
                                size='sm'
                                className='btn-resend'
                                data-bs-toggle='modal'
                                data-bs-target='#emailResendConfirmationModal'
                                title="Renvoyer l'email"
                            >
                                <span className='icon'></span>
                                <span className='text'>Renvoyer</span>
                            </Button>
                        </div>
                    </td>
                </tr>
        );
    });

    return <>{rows}</>;
}
